// Resolves operatorPrice for a stored tripOption.
// One-way: operatorPrice is a flat field on the option.
// Round trip: pick the variant from priceBreakdown matching lowestPrice.
const getTripOptionOperatorPrice = (option, tripType) => {
  if (!option) return null;

  if (tripType === 1) {
    return option.operatorPrice ?? null;
  }

  if (tripType === 2) {
    const bd = option.priceBreakdown || {};
    switch (option.lowestPrice) {
      case "ptp2":
        return bd.operatorPricePointToPoint2 ?? null;
      case "otg":
        return bd.operatorPriceOnTheGround ?? null;
      case "drt":
        return bd.operatorPriceDoubleRoundTrip ?? null;
      default:
        return null;
    }
  }

  return null;
};

export default getTripOptionOperatorPrice;
